
import IconButton from '@mui/joy/IconButton';
import Tooltip from '@mui/joy/Tooltip';

import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { Link, useNavigate } from 'react-router-dom';
import WarningDialog from './dialogs/WarningDialog';
import { additionalSx } from '@utils/additionalSx';

export default function DeleteButton({sx = {}, onDelete, ...props}) {
    /*
    const navigate = useNavigate();

    const onClick = () => {
        //props.onClick
        navigate("create", { relative: "path" });
    }
    */

    const confirmDelete = () => {
        console.log('will delete');
        //
    };

    return (
        <WarningDialog
            title="Confirm Delete"
            content={props?.content ?? <>Are you sure you want to delete this?</>}
            confirmText="Delete"
            onConfirm={onDelete}
            activateButton={(btnProps)=>
                <Tooltip title={props?.tooltip ?? 'Delete'} disableInteractive>
                    <IconButton
                        color="neutral"
                        size="sm"
                        // variant="plain"
                        variant="outlined"
                        // component={Link}
                        // to="../" relative='path'
                        /*
                        color="neutral"
                        */
                        // sx={{mr: 2}}

                        sx={theme => ({
                            // mr: 2,
                            color: 'white',
                            bgcolor: 'background.surface',
                            transition: 'all .2s linear',
                            // bgcolor: theme.palette.danger[100],// 'background.palette.danger'
                            // borderColor: theme.palette.danger[200],
                            ':hover': {
                                bgcolor: theme.palette.danger[500],
                                borderColor: theme.palette.danger[600],
                            },
                            ...additionalSx(theme, sx),
                        })}

                        // onClick={cancelEditing}
                        {...props}
                        {...btnProps}
                        >
                        <DeleteForeverRoundedIcon />
                    </IconButton>
            </Tooltip>
            }
        />
    );
}
